export default {
  SYSTEM_ID: '0x53797374656d0000000000000000000000000000000000000000000000000000',
  ADDRESS_ZERO: '0x0000000000000000000000000000000000000000',
  BYTES32_ZERO: '0x0000000000000000000000000000000000000000000000000000000000000000',
}
